<footer class="footer">
  <div class="container">
    <div class="footer-box">
      <div class="footer-info">
        <span> © {{ year }}</span>
        <a
          class="footer-info__link"
          href="https://www.controlinsurancesolutions.com.au/"
          target="_blank">
          Control Insurance Solutions
        </a>
        <br />
        Pty Ltd. All rights reserved.
      </div>
    </div>
  </div>
</footer>
